<!--
  @负责人: xiehan
  @创建时间: 2019-02-19
  @版本:v2.0.2
  @描述: 流程管理-模板管理
-->

<template>
  <div class="workFlowTemplateManage">
    <div>
      <el-radio-group v-model="type" @change="typeChange">
        <el-radio-button v-for="(val, key) in select_type" :label="key" :key="key">{{ val }}</el-radio-button>
      </el-radio-group>
    </div>
    <el-button type="primary"
      class="mb-base mt-base" 
      v-g-rac="gRac('workFlowTemplateManage@add')"
      @click="addTemplate"
      v-text="$t('common.add')"></el-button>
    <el-row>
      <div v-show="templateList.length > 0" v-for="item in templateList" :key="item.id" class="template__single" :title="item.name">
        <i class="icon iconfont icon-amc_circle_close icon-delete" @click="deleteTemplate(item.id)" v-g-rac="gRac('workFlowTemplateManage@delete')"></i>
        <el-button type="primary" size="large" plain @click="checkTemplate(item.id)">{{item.name}}</el-button>
      </div>
      <div v-show="templateList.length === 0" v-text="$t('common.noData')" style="text-align: center;"></div>
    </el-row>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import workFlowTemplateManageBiz from '@/logic/workFlow/workFlowTemplateManageBiz'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        templateList: [],
        type: '',
        select_type: {}
      }
    },
    methods: {
      async preInitDic () {
        await Promise.all([
          this.dGetDictionaryByCode('orderType')
        ])
        this.select_type = { ...this.dDictionary.orderType }
        this.type = this.type || Object.keys(this.select_type)[0]
        this.getTemplate(this.type)
      },
      addTemplate () {
        this.$router.push({ name: 'handlerWorkFlowTemplate', query: { type: this.type } })
      },
      getTemplate (type) {
        workFlowTemplateManageBiz.findTemplate({ type: type }).then((res) => {
          this.templateList = res
        })
      },
      typeChange (val) {
        this.getTemplate(val)
      },
      deleteTemplate (id) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          workFlowTemplateManageBiz.deleteTemplate({ id: id }).then(() => {
            this.getTemplate()
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
          })
        }).catch(() => {})
      },
      checkTemplate (id) {
        this.$router.push({ name: 'handlerWorkFlowTemplate', query: { id: id } })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'workFlowTemplateManage' && from.name === 'handlerWorkFlowTemplate') {
          this.preInitDic()
        }
      }
    },
    mounted () {
      this.preInitDic()
    }
  }
</script>

<style scoped>
  .el-button--primary.is-plain{
    height: 80px;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 20px;
    margin-right: 16px;
    margin-left: 0;
  }
  .template__single {
    display: inline-block;
    position: relative;
  }
  .template__single:hover .icon-delete {
    display: block;
  }
  .template__single .icon-delete {
    display: none;
    color: #0B8DE5;
    font-size: 18px;
    position: absolute;
    top: -8px;
    right: 8px;
    cursor: pointer;
  }
  .template__single .icon-delete:hover {
    color: #0B8DE5;
  }
</style>